import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '焦点专题', href: '#carousel' },
    { label: '爆料视频', href: '#media' },
    { label: '实时快讯', href: '#updates' },
    { label: '关于我们', href: '#about' },
    { label: '热度榜单', href: '#ranking' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-xl border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            className="flex items-center gap-2 text-foreground-50 font-bold text-xl tracking-tight whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
              <i className="ri-flashlight-fill text-background-950 text-sm"></i>
            </span>
            51爆料网
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-4 py-2 text-sm text-foreground-300 hover:text-accent-400 transition-colors rounded-lg hover:bg-background-100/80 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              className="hidden md:flex w-9 h-9 items-center justify-center rounded-full bg-background-100 border border-background-200/50 text-foreground-300 hover:text-accent-400 hover:border-accent-500/30 transition-all cursor-pointer"
              aria-label="用户"
            >
              <i className="ri-user-3-line text-sm"></i>
            </button>
            <button
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-200 hover:text-accent-400 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50/95 backdrop-blur-xl border-b border-background-200/50 px-4 pb-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="block px-4 py-3 text-sm text-foreground-300 hover:text-accent-400 transition-colors rounded-lg hover:bg-background-100/80 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}